"use strict";
/**
 * Ось B — ПЛАТФОРМЕННАЯ ДОЛЖНОСТЬ (RBAC-1 AD-1).
 *
 * «Сотрудник платформы»: 0..n ролей, по умолчанию 0, назначает человек и редко.
 * Ось B — единственная, где имя роли законно участвует в решении о доступе: у
 * платформенного админа членств НЕТ и не будет (RBAC-1.3 Р-6), поэтому его ветка
 * не может прийти из членства и обязана прийти из имени.
 *
 * Здесь перечислены роли оси B, КОТОРЫЕ ВЕЗЁТ ПЛАТФОРМА. Словарь описывает то, что
 * платформа поставляет и на что смеет ссылаться код, а не то, что кто-то проверяет, —
 * иначе сторож AC-8 начнёт краснеть на правде.
 *
 * ⚠ RBAC-3.3 СУЗИЛА эту формулировку, и это решение, а не редактура. До неё здесь стояло
 * «перечислены ВСЕ живые имена; словарь описывает то, что лежит в базе», и это перестало
 * быть правдой в первый же день после того, как оператор получил `POST /admin/roles`:
 * роли `scope='custom'`, заведённые из админки, живут ТОЛЬКО В БАЗЕ и сюда не попадают.
 * Ничего при этом не покраснеет — инвариант 1.9 AC-2 односторонний: сторож проверяет, что
 * имя, названное ГЕЙТОМ, объявлено в словаре, а не что база ⊆ словарь. Оставить прежнюю
 * шапку значило бы держать в файле утверждение, опровергаемое первым же нажатием кнопки.
 *
 * Отсюда граница, и она жёсткая: **роль `scope='custom'`, заведённая оператором, не имеет
 * права появляться ни в одном гейте.** Доступ ей даёт СОСТАВ ПРАВ и только он. Гейт,
 * назвавший такое имя, решал бы по имени, которого нет в словаре, — то есть вернул бы
 * ровно то, что эпик истребляет (`catalog_admin`: роль с нулём прав, открывавшая 44
 * маршрута своим именем).
 *
 * ⚠ RBAC-2.5 сняла отсюда `merchant`, `readonly` и `test_perf_role`, RBAC-3.7 —
 * `catalog_admin`; все четыре выведены из обращения миграциями. Заводить их заново
 * нельзя: словарь и база обязаны говорить одно и то же, и односторонний инвариант 1.9
 * AC-2 («схема ⊆ словарь») эту сторону НЕ проверяет.
 *
 * ⚠ `moderator` и `content_manager` мёртвыми БЫТЬ ПЕРЕСТАЛИ и из списка на удаление
 * выведены: первой RBAC-2.4 выдала `conversations:read_all`, второй RBAC-2.9 —
 * `content:moderate` и `manage_news`. Обе при этом остаются именами, которых НЕ
 * называет ни один гейт: доступ им даёт право, и снятие права отнимает его у всех
 * держателей разом — в этом и был предмет эпика.
 *
 * ⚠ RBAC-3.7 СНЯЛА ОТСЮДА `catalog_admin` — та самая «следующая уборка», которую обещал
 * этот абзац. Роль жила с НУЛЁМ прав ровно потому, что её ИМЯ называл гейт
 * `CatalogRoles.ADMIN`; 44 MDM-маршрута Catalog теперь спрашивают право
 * (`mdm:manage` / `enrichment:manage` / `content:moderate`), группы имён в Catalog не
 * осталось, и роль выведена из обращения миграцией
 * `2026-08-30_rbac_3_7_mdm_permissions.sql`. Заводить её заново нельзя по той же
 * причине, что `merchant`/`readonly`: инвариант 1.9 AC-2 односторонний.
 *
 * ⚠ Фантомов здесь нет и не будет. `platform_admin`, `merchant_owner`,
 * `merchant_manager`, `merchant_staff`, `merchant_operator` не существуют ни на dev,
 * ни на проде — снято запросом к обеим базам 2026-08-27. Имя-фантом в гейте не
 * отказывает и не пускает: решение принимает то, что осталось в списке рядом.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLATFORM_ADMIN_ROLE_NAMES = exports.PLATFORM_ROLE_VALUES = exports.PLATFORM_ROLES = void 0;
exports.isPlatformAdmin = isPlatformAdmin;
exports.PLATFORM_ROLES = {
    SUPER_ADMIN: 'super_admin',
    ADMIN: 'admin',
    SUPPORT: 'support',
    MODERATOR: 'moderator',
    CONTENT_MANAGER: 'content_manager',
};
exports.PLATFORM_ROLE_VALUES = Object.values(exports.PLATFORM_ROLES);
/**
 * «Платформенный админ» — ОДНО объявление на всю платформу.
 *
 * До RBAC-1.9 этот набор был выписан руками в шести местах, и в четырёх из них вторым
 * именем стоял фантом `platform_admin`. Следствия расходились: гейт 16 админских
 * маршрутов Core сужался до одного `super_admin` (хотя роутером выше уже пущен
 * `admin`), `super_admin` не видел `admin_only` категорий в каталоге, а ops-алерт о
 * провале провижининга не доходил до `admin`. Три разных поведения из одной опечатки —
 * потому что копий было шесть.
 *
 * ⚠ AD-10 — набор `['super_admin', 'admin']` есть РЕШЕНИЕ оператора (2026-08-27), а не
 * орфография. Гейт всегда обещал «платформенный админ», и gateway на тех же путях уже
 * пускает `admin` (`required_roles: [admin, super_admin]` во всех 77 записях); после
 * правки два слоя enforcement перестают утверждать разное. Цена сегодня нулевая:
 * держателей `admin` на проде 0, на dev 1.
 */
exports.PLATFORM_ADMIN_ROLE_NAMES = [
    exports.PLATFORM_ROLES.SUPER_ADMIN,
    exports.PLATFORM_ROLES.ADMIN,
];
/** Держит ли этот набор ролей платформенного админа. */
function isPlatformAdmin(roles) {
    if (!roles)
        return false;
    return roles.some((role) => exports.PLATFORM_ADMIN_ROLE_NAMES.includes(role));
}
